export { default as CarouselBI } from './plugins/carousel-bi'
export { default as InputNumber } from './plugins/input-number'
export { default as Dimmer } from './plugins/dimmer'
export { default as Notification } from './plugins/notification'
export { default as Cookiebar } from './plugins/cookiebar'
export { default as NavBarCollapsible } from './plugins/navbar-collapsible'
export { default as Accordion } from './plugins/accordion'
export { default as NavScroll } from './plugins/navscroll'
export { default as Sticky } from './plugins/sticky'
export { default as TrackFocus } from './plugins/track-focus'
export { FormValidate, ValidatorSelectAutocomplete } from './plugins/form-validate'
export { default as Input } from './plugins/input'
export { default as SelectAutocomplete } from './plugins/select-autocomplete'
export { default as InputSearchAutocomplete } from './plugins/input-search-autocomplete'
export { default as InputPassword } from './plugins/input-password'
export { default as ProgressDonut } from './plugins/progress-donut'
export { default as UploadDragDrop } from './plugins/upload-dragdrop'
export { default as BackToTop } from './plugins/backToTop'
export { default as HistoryBack } from './plugins/history-back'
export { default as Forward } from './plugins/forward'
export { default as Masonry } from './plugins/masonry'
export { default as List } from './plugins/list'
export { default as Transfer } from './plugins/transfer'

/* Bootstrap */
export { default as Alert } from './plugins/alert'
export { default as Button } from './plugins/button'
export { default as Carousel } from './plugins/carousel'
export { default as Collapse } from './plugins/collapse'
export { default as Dropdown } from './plugins/dropdown'
export { default as Modal } from './plugins/modal'
export { default as Offcanvas } from './plugins/offcanvas'
export { default as Popover } from './plugins/popover'
export { default as ScrollSpy } from './plugins/scrollspy'
export { default as Tab } from './plugins/tab'
export { default as Toast } from './plugins/toast'
export { default as Tooltip } from './plugins/tooltip'

/* Side effects */
import './plugins/fonts-loader.js'
import './plugins/header-sticky'
import BOOTSTRAP_ITALIA_VERSION from './version'

window.BOOTSTRAP_ITALIA_VERSION = BOOTSTRAP_ITALIA_VERSION
